const env = 'test' // 正式production 测试test/105 本地development
const ssoEnv = 'test' // 正式production  测试test

// 本系统接口地址
const switchSystemLinkApi = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://api.official.53tech.cn/api/'
      break;
    case 'test':
      str = 'https://dev.api.official.53tech.cn/api/'
      break;
    case '105':
      str = 'http://192.168.0.105:45534/api/'
      break;
    case 'development':
      str = 'http://192.168.0.105:45534/api/' // http://192.168.0.105:45534/api/  http://192.168.0.239:45534/api/
      break;
  }
  return str
})

// 统一登录接口地址
const switchSsoLinkApi = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://api.sso.53tech.cn/api/'
      break;
    case 'test':
      str = 'http://dev.api.sso.53tech.cn/api/'
      break;
  }
  return str
})

// 本系统地址
const switchSystemLink = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://www.53tech.cn'
      break;
    case 'test':
      str = 'http://dev.www.53tech.cn' // https://dev.official.53tech.cn（暂无）
      break;
    case '105':
      str = 'http://192.168.0.105:8081'
      break;
    case 'development':
      str = 'http://192.168.0.241:8081'
      break;
  }
  return str
})

// 统一登录地址
const switchSsoLink = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://sso.53tech.cn'
      break;
    case 'test':
      str = 'http://dev.sso.53tech.cn'
      break;
  }
  return str
})

// 配置gpt体验版地址
const switchExperienceLink = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://chatgpt.53tech.cn'
      break;
    case 'test':
      str = 'http://dev.chatgpt.53tech.cn'
      break;
    case '105':
      str = 'http://192.168.0.105:8082'
      break;
    case 'development':
      str = 'http://192.168.0.105:8082'
      break;
  }
  return str
})

// 配置项目追踪地址
const switchTrackLink = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://www.53track.cn'
      break;
    case 'test':
      str = 'http://dev.www.53track.cn'
      break;
    case '105':
      str = 'http://192.168.0.105:8083'
      break;
    case 'development':
      str = 'http://192.168.0.105:8083'
      break;
  }
  return str
})

// 配置线上服务站地址
const switchServiceStationLinkLink = ((value) => {
  let str = ''
  switch (value) {
    case 'production':
      str = 'https://service.station.53tech.cn'
      break;
    case 'test':
      str = 'http://dev.service.station.53tech.cn'
      break;
    case '105':
      str = 'http://192.168.0.105:8086'
      break;
    case 'development':
      str = 'http://192.168.0.105:8086'
      break;
  }
  return str
})

module.exports = {
  // 图片资源请求地址
  imgHttpUrlHref: 'https://api.official.53tech.cn/imgs/',
  systemLinkApi: switchSystemLinkApi(env),
  ssoLinkApi: switchSsoLinkApi(ssoEnv),
  systemLink: switchSystemLink(env),
  ssoLink: switchSsoLink(ssoEnv),
  experienceLink: switchExperienceLink(env),
  trackLink: switchTrackLink(env) + '/enterPriseCenter/versionUp',
  serviceStationLink: switchServiceStationLinkLink(env),
  env
}



// WEBPACK FOOTER //
// ./src/settings.js